const urls = {
    gform_1: "https://www2.jenseninvestment.com/l/765833/2023-08-16/34n1n8",
    gform_2: "https://www2.jenseninvestment.com/l/765833/2023-07-10/33xgdn",
    gform_4: "https://www2.jenseninvestment.com/l/765833/2023-07-10/33xhhv",
    gform_5: "https://www2.jenseninvestment.com/l/765833/2023-07-11/33xw4y",
    gform_6: "https://www2.jenseninvestment.com/l/765833/2023-07-11/33xwdg",
};

const mapFields = (originalData, formID) => {
    const mappedData = {};
    switch (formID) {
        case "gform_1":
            mappedData.first_name = originalData.input_3;
            mappedData.email = originalData.input_8;
            mappedData.last_name = originalData.input_4;
            mappedData.company_name = originalData.input_17;
            break;
        case "gform_2":
            mappedData.email = originalData.input_5;
            break;
        case "gform_4":
            mappedData.email = originalData.input_4;
            mappedData.first_name = originalData.input_1;
            mappedData.last_name = originalData.input_3;
            mappedData.message = originalData.input_5;
            break;
        case "gform_5":
            mappedData.email = originalData.input_6;
            mappedData.first_name = originalData.input_1;
            mappedData.last_name = originalData.input_3;
            mappedData.message = originalData.input_5;
            break;
        case "gform_6":
            mappedData.email = originalData.input_4;
            mappedData.first_name = originalData.input_1;
            mappedData.last_name = originalData.input_3;
            mappedData.company = originalData.input_5;
            mappedData.metropolitan_area = originalData.input_6;
            break;
        default:
            // eslint-disable-next-line no-console
            console.log("Form ID not found");
    }
    return mappedData;
};

const sendData = async (mappedData, formID) => {
    try {
        let url = urls[formID] ?? "";
        if (!url) {
            // eslint-disable-next-line no-console
            console.log("URL not found, please check if url is added in code");
            return;
        }

        if (Object.keys(mappedData).length > 0) {
            const queryParams = new URLSearchParams(mappedData).toString();
            const separator = url.includes("?") ? "&" : "?";
            url += `${separator}${queryParams}`;
        }

        const iframe = document.createElement("iframe");
        iframe.src = url;
        iframe.width = "100%";
        iframe.height = "400px";
        iframe.className = "gg-pardot-form-iframe d-none";
        document.body.appendChild(iframe);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log("Something not work with sending to Pardot", error);
    }
};

const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);
    const originalData = Object.fromEntries(formData);
    if (!originalData) {
        return;
    }
    if (
        !originalData.version_hash &&
        window.gf_global &&
        window.gf_global.version_hash
    ) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = "version_hash";
        input.id = "version_hash";
        input.value = window.gf_global.version_hash;
        form.appendChild(input);
    }
    const mappedData = mapFields(originalData, form.id);
    // eslint-disable-next-line no-undef
    jQuery(document).bind("gform_confirmation_loaded", async () => {
        await sendData(mappedData, form.id);
    });
    event.target.submit();
};

export const initPardotIntegrationForm = () => {
    document.querySelectorAll("form").forEach((element) => {
        element.addEventListener("submit", handleSubmit);
    });
};
